var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c(
        "div",
        { staticClass: "col-sm-12 col-md-12 col-lg-8" },
        [
          _c(
            "div",
            { ref: "videoWrapper", staticClass: "video-wrapper" },
            [
              _vm.isLocked
                ? [
                    _vm.lockedVideoInfo.thumbnail
                      ? _c("img", {
                          staticClass: "locked-thumbnail",
                          attrs: { src: _vm.lockedVideoInfo.thumbnail }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("paywall-overlay", {
                      attrs: { video: _vm.lockedVideoInfo },
                      on: { onBuy: _vm.onBuy, onUpgrade: _vm.onUpgrade }
                    })
                  ]
                : [
                    _c("div", { ref: "player" }),
                    _vm._v(" "),
                    !_vm.isYoutubeVideo
                      ? _c("iframe", {
                          ref: "iframe",
                          attrs: {
                            src: _vm.video.url,
                            frameborder: "0",
                            allow:
                              "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                            allowfullscreen: "",
                            referrerpolicy: "strict-origin-when-cross-origin"
                          }
                        })
                      : _vm._e()
                  ]
            ],
            2
          ),
          _vm._v(" "),
          _c("h2", { staticClass: "video-title" }, [
            _vm._v(_vm._s(_vm.video.title))
          ]),
          _vm._v(" "),
          _c("video-header", {
            attrs: { category: _vm.category, video: _vm.video },
            on: { handleLikeVideo: _vm.handleLikeVideo }
          }),
          _vm._v(" "),
          _c("video-description", {
            staticClass: "mr-b-10",
            attrs: { video: _vm.video },
            on: { seekTo: _vm.handleSeek }
          }),
          _vm._v(" "),
          _c("h3", { staticClass: "font-bold" }, [
            _vm._v(_vm._s(_vm.video.comments) + " 件のコメント")
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "videoCommentsWrapper",
              staticClass: "video-comments-wrapper"
            },
            [
              _c("video-comments", {
                attrs: {
                  video: _vm.video,
                  comments: _vm.comments,
                  sellerId: _vm.sellerId
                },
                on: {
                  submitComment: _vm.submitComment,
                  updateComment: _vm.updateComment,
                  handleLikeComment: _vm.handleLikeComment,
                  submitReply: _vm.submitReply,
                  seekTo: _vm.handleSeek
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-sm-12 col-md-12 col-lg-4" },
        [
          _vm.isLocked && _vm.lockedVideoInfo.price
            ? _c("div", { staticClass: "ppv-panel" }, [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "ppv-option",
                    class: { selected: _vm.ppvOption === "ppv" }
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.ppvOption,
                          expression: "ppvOption"
                        }
                      ],
                      attrs: { type: "radio", value: "ppv" },
                      domProps: { checked: _vm._q(_vm.ppvOption, "ppv") },
                      on: {
                        change: function($event) {
                          _vm.ppvOption = "ppv"
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "ppv-option-body" }, [
                      _c("div", { staticClass: "ppv-option-title" }, [
                        _vm._v("この動画を購入")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "ppv-option-price" }, [
                        _c("span", { staticClass: "ppv-tax-included" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.formatPrice(_vm.lockedVideoInfo.price)
                              ) +
                              "円\n              "
                          ),
                          _c("span", { staticClass: "ppv-tax-label" }, [
                            _vm._v(
                              "（税込 " +
                                _vm._s(
                                  _vm.formatPrice(
                                    _vm.lockedVideoInfo.totalPrice
                                  )
                                ) +
                                " 円）"
                            )
                          ])
                        ])
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "ppv-option",
                    class: { selected: _vm.ppvOption === "upgrade" }
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.ppvOption,
                          expression: "ppvOption"
                        }
                      ],
                      attrs: { type: "radio", value: "upgrade" },
                      domProps: { checked: _vm._q(_vm.ppvOption, "upgrade") },
                      on: {
                        change: function($event) {
                          _vm.ppvOption = "upgrade"
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "ppv-option-body" }, [
                      _c("div", { staticClass: "ppv-option-title" }, [
                        _vm._v("プレミアムに登録")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "ppv-option-price" }, [
                        _c("span", { staticClass: "ppv-pretax" }, [
                          _vm._v("全てのプレミアム動画が見放題")
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "ppv-tax-included" }, [
                          _vm._v(_vm._s(_vm.formattedPriceExTaxMonth) + "円"),
                          _c("span", { staticClass: "ppv-tax-label" }, [
                            _vm._v(
                              "/月（税込 " +
                                _vm._s(_vm.formattedPriceInTaxMonth) +
                                " 円）"
                            )
                          ])
                        ])
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm.ppvOption === "ppv"
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        on: { click: _vm.onBuy }
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-shopping-cart",
                          attrs: { "aria-hidden": "true" }
                        }),
                        _vm._v("\n        動画を購入\n      ")
                      ]
                    )
                  : _c(
                      "button",
                      {
                        staticClass: "btn btn-upgrade-premium",
                        on: { click: _vm.onUpgrade }
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-diamond",
                          attrs: { "aria-hidden": "true" }
                        }),
                        _vm._v("\n        プレミアムに登録\n      ")
                      ]
                    )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("related-videos", {
            ref: "relatedVideos",
            attrs: { videos: _vm.videos, categoryId: _vm.categoryId },
            on: {
              handleClickViewVideo: function($event) {
                _vm.$emit("handleClickViewVideo", $event)
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.isShowModal
        ? _c("modal-alert", {
            attrs: { message: _vm.message },
            on: { close: _vm.closeModal }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ppv-header" }, [
      _c("i", {
        staticClass: "fa fa-diamond",
        attrs: { "aria-hidden": "true" }
      }),
      _vm._v("\n        プレミアム限定動画\n      ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7bd93eb7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bd93eb7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/video/VideoPlayer.vue
// module id = null
// module chunks = 